import script from "./CadTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./CadTerms.vue?vue&type=script&setup=true&lang=js"

import "./CadTerms.vue?vue&type=style&index=0&id=b61d77ac&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b61d77ac"]])

export default __exports__